enum IdTypeEnum {
    DriverLicence = 'DRIVER_LICENCE',
    Passport = 'PASSPORT',
}

export default IdTypeEnum;
